module.exports = __webpack_public_path__ + "media/country_flags/mk-30f10a5a.png";